import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetEnclosureCardAction } from '../../actions/enclosure-cards/get-enclosure-card-action';
import { GetEnclosureCardSuccessAction } from '../../actions/enclosure-cards/get-enclosure-card-success-action';
import { GetEnclosureCardErrorAction } from '../../actions/enclosure-cards/get-enclosure-card-error-action';

@Injectable()
export class GetEnclosureCardEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetEnclosureCardsActions = createEffect(() => this.actions
    .pipe(
      ofType(GetEnclosureCardAction.type),
      mergeMap(action => {
        const getEnclosureCardAction = <GetEnclosureCardAction>action;
        return this.api.getEnclosureCard(getEnclosureCardAction.group).then(enclosureCard => {
          return new GetEnclosureCardSuccessAction(enclosureCard);
        }, error => {
          return new GetEnclosureCardErrorAction({ ...error, fatal: true });
        });
      })
    ));
}
